﻿$.fn.dxCtrlConfigEnvoi = function custom_dxCtrlConfigEnvoi(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlconfigenvoi dx-ctrl");
        this.createInstance(new cdxCtrlConfigEnvoi(this, option));
    }
    return this;
}

window.cdxCtrlConfigEnvoi = function (container, option) {
    var Me = this;


    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var $DivPreview = null
    var $TdEvalPlannification = null
    var $DivResumeEnvoi = null
    var table = null
    var dxBtEnvoyer = null
    function mConstruit() {
        container.css("height", ((container.innerHeight() == 0) ? "" : container.innerHeight() + 'px'))
        container.empty();


        table = option.bddCtrl.getObjet(option.data).mGetTable()
        if (option.lstDesComSource.length != option.lstDestComNettoye.length) {
            var $DivNb = $("<div style='padding:0 15px;text-align:center;'/>").appendTo(container)
            var $Table = $("<table style='font-size:130%;display:inline-block;" + ((option.lstDestComNettoye.length == 0) ? "color:red;" : "") + "'/>").appendTo($DivNb)
            var $Tr = $("<tr/>").appendTo($Table)
            var $Td = $("<td style='width:1px;white-space:nowrap;font-family:Barlow Condensed;font-size:500%;padding-right:5px;'>" + option.lstDestComNettoye.length + "</td>").appendTo($Tr)
            switch (table.nom) {
                case "com_email_envoi":
                    var $Td = $("<td style='width:1px;white-space:nowrap;vertical-align:middle;text-align:left;'>destinataires pour votre <b>ENVOI</b><br/>après supression des doublons,<br/>sans adresse, hard et soft bounce.</td>").appendTo($Tr)
                    break;
                case "com_sms_envoi":
                    var $Td = $("<td style='width:1px;white-space:nowrap;vertical-align:middle;text-align:left;'>destinataires pour votre <b>ENVOI</b><br/>après supression des doublons et<br/>sans téléphone.</td>").appendTo($Tr)
                    break;
            }
        }

        if (table.nom == "com_sms_envoi") {
            $("<div style='margin:5px'/>").appendTo(container).dxCtrlWarningForm({
                type: "error",
                html: function () {
                    return "<div style='font-size:80%;'>Merci de vous assurer que les messages que vous comptez envoyer respectent la législation en cours sur le territoire français et international en prohibant, sans que cette liste soit limitative :" +
                        "<ul style='list-style: circle;padding-left:20px;'>" +
                        "<li>tout contenu à caractère raciste, antisémite, xénophobe, révisionniste, pornographique, menaçant, injurieux, violent ou portant atteinte d'une quelconque manière à l'ordre public et la dignité humaine,</li>" +
                        "<li>l'incitation à la consommation de substances interdites,</li>" +
                        "<li>l'encouragement à la violence, la réalisation de crimes et délits,</li>" +
                        "<li>tout acte délictueux, fraude et escroquerie,</li>" +
                        "<li>toute utilisation ou transmission de virus informatiques, codes ou programmes ayant pour objectif d'infecter, prendre le contrôle ou interagir avec tout téléphone, tablette, ordinateur ou logiciel,</li>" +
                        "</ul>" +
                        "Sont aussi interdis tous les envois :" +
                        "<ul style='list-style: circle;padding-left:20px;'>" +
                        "<li>de nature politique ou religieuse</li>" +
                        "<li>en vue de la réalisation d'économies d'énergie ou de la production d'énergies renouvelables</li>" +
                        "<li>en rapport avec le CPF </li>" +
                        "</ul></div>"
                }
            })
            $("<br/>").appendTo(container)
        }

        $DivPreview = $("<div style='background-color: dimgrey;padding:0 10px 15px 10px;'/>").appendTo(container)
        mRempliPreview()

        var $Table = $("<table/>").appendTo(container)

        //expéditeur
        var $Tr = $("<tr style=''/>").appendTo($Table)
        var $Td = $("<td style='white-space:nowrap;padding:15px 10px 0px 10px;font-size:160%;font-weight:bold;' colspan='2' class='dx-theme-accent-as-text-color'>Expéditeur (De:)</td>").appendTo($Tr)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='padding:0 10px;' colspan='2'></td>").appendTo($Tr)
        $("<div style='margin:10px;'/>").appendTo($Td).dxCtrlContentEnvoiMailingDe({
            bddCtrl: option.bddCtrl,
            type: ((table.nom == "com_email_envoi") ? "email" : ((table.nom == "com_sms_envoi") ? "sms" : "")),
            data:option.data
        })
        //switch (table.nom) {
        //    case "com_email_envoi":
        //        //saisie adresse email + dns
        //        var dataCompteEmail = option.bddCtrl.getObjet(option.bddCtrl.utiCourant).objetMetier.mGetLstDataCompteEmail().filter(function (dataCpteEmail) {
        //            return dataCpteEmail.id_compte_email == option.data.id_compte_email
        //        })[0]
        //        var dxCtrlEmailExp = $("<div style='margin:10px;'/>").appendTo($Td).dxCtrlSelectBoxCompteEmail({
        //            bddCtrl: option.bddCtrl,
        //            readOnly: false,
        //            value: dataCompteEmail,
        //            onValueChanged: function (e) {
        //                option.data.id_compte_email = e.value.id_compte_email
        //                option.data.email_expediteur = e.value.adresse_email
        //                option.bddCtrl.getObjet(option.data).mSave()
        //                dxConfDns.option("adresse_email", option.data.email_expediteur)
        //                dxConfDns.mReload()
        //            }
        //        }).dxCtrlSelectBoxCompteEmail("instance")
        //        var dxConfDns = $("<div style='margin:0 30px 15px 30px;min-height:55px;'/>").appendTo($Td).dxCtrlCompteEmailConfigEnvoiDns({
        //            bddCtrl: option.bddCtrl,
        //            adresse_email: option.data.email_expediteur,
        //        }).dxCtrlCompteEmailConfigEnvoiDns("instance")
        //        break;
        //    case "com_sms_envoi":
        //        //saisie emetteur
        //        if (option.data.emetteur == null || option.data.emetteur.length == 0) option.data.emetteur = option.bddCtrl.paraAppli.mGetPara("sms_emetteur")
        //        $("<div style='margin-bottom:15px;'/>").appendTo($Td).dxCtrlSaisieEmetteurSms({
        //            bddCtrl: option.bddCtrl,
        //            afficheAide: true,
        //            value: option.data.emetteur,
        //            onValueChanged: function (e) {
        //                option.data.emetteur = e.value.toUpperCase()
        //                option.bddCtrl.getObjet(option.data).mSave("emetteur")
        //            }
        //        })
        //        break;
        //}



        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='white-space:nowrap;padding:15px 10px 5px 10px;font-size:160%;font-weight:bold;background-color:dimgrey;' colspan='2' class='dx-theme-accent-as-text-color'>Propriétés de vos envois</td>").appendTo($Tr)

        //hébergement image
        switch (table.nom) {
            case "com_email_envoi":
                var $Tr = $("<tr style='background-color:dimgrey;'/>").appendTo($Table)
                var $Td = $("<td style='white-space:nowrap;width:100%;padding:5px 0 0 10px;opacity:0.2;'>Héberger les images</td>").appendTo($Tr)
                var $Td = $("<td style='white-space:nowrap;width:1px;text-align:right;padding:5px 10px 5px 0;'/>").appendTo($Tr)
                $("<div/>").appendTo($Td).dxCtrlSwitch({
                    value: (option.data.heberger_image == "1"),
                    onValueChanged: function (e) {
                        option.data.heberger_image = ((e.value) ? "1" : "0")
                        option.bddCtrl.getObjet(option.data).mSaveChamp("heberger_image")
                        if (typeof option.onValueChanged != 'undefined') option.onValueChanged()
                        mRempliResumeEnvoi()
                    }
                })
                break;
            default: break;
        }

        //tracking
        switch (table.nom) {
            case "com_email_envoi": case "com_sms_envoi":
                var $Tr = $("<tr style='background-color:dimgrey;'/>").appendTo($Table)
                var $Td = $("<td style='white-space:nowrap;width:100%;padding:5px 0 5px 10px;opacity:0.2;'>Tracking</td>").appendTo($Tr)
                var $Td = $("<td style='white-space:nowrap;width:1px;text-align:right;padding:5px 10px 5px 0;'/>").appendTo($Tr)
                $("<div/>").appendTo($Td).dxCtrlSwitch({
                    value: (option.data.tracking == "1"),
                    onValueChanged: function (e) {
                        option.data.tracking = ((e.value) ? "1" : "0")
                        option.bddCtrl.getObjet(option.data).mSaveChamp("tracking")
                        if (typeof option.onValueChanged != 'undefined') option.onValueChanged()
                        mRempliPreview()
                        mRempliResumeEnvoi()
                    }
                })
                break;
            default: break;
        }

        //plannification
        switch (table.nom) {
            case "com_email_envoi": case "com_sms_envoi":
                var $Tr = $("<tr/>").appendTo($Table)
                var $Td = $("<td style='white-space:nowrap;padding:15px 10px 5px 10px;font-size:160%;font-weight:bold;' colspan='2' class='dx-theme-accent-as-text-color'>Plannification de vos envois</td>").appendTo($Tr)
                var $TableCadencement = $("<table/>").appendTo(container)
                //var $Tr = $("<tr/>").appendTo($Table)
                //var $Td = $("<td style='white-space:nowrap;padding:15px 0 5px 0;font-size:160%;border-bottom:1px solid black;' colspan='2'>Plannification de vos envois</td>").appendTo($Tr)
                $TableCadencement.dxCtrlConfigEnvoiCadencement({
                    bddCtrl: option.bddCtrl,
                    data: option.data,
                    onValueChanged: option.onValueChanged
                })

                //$Table = $("<table>").appendTo(container)
                break;
            default: break;
        }

        //taille message  
        $DivResumeEnvoi = $("<div style='background-color:dimgrey;padding:0 10px;'/>").appendTo(container)
        mRempliResumeEnvoi()

        //envoyer
        var $Table = $("<table style='width:100%;'>").appendTo(container)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='padding-top:10px;text-align:center;' colspan='2'></td>").appendTo($Tr)
        dxBtEnvoyer = $("<div style='display:inline-block;'/>").appendTo($Td).dxCtrlButton({
            text: "Envoyer",
            onClick: function (e) {
                if (option.lstDestComNettoye.length == 0) {
                    mNotify("Vous n'avez aucun destinataire sur votre message après nettoyage<br/>Impossible d'envoyer votre message", "error", 6000)
                } else if (option.lstDesComSource.length != option.lstDestComNettoye.length) {
                    var tt = $("<div/>").appendTo("body").dxCtrlTooltip({
                        target: e.component.element(),
                        position: "top",
                        contentTemplate: function (contentElement) {
                            contentElement.css("padding", "35px")
                            contentElement.css("font-size", "120%")
                            $("<div>Avant l'envoi de votre message,<br/>les destinataires doivent être nettoyés<br/>(doublons, sans adresse...).<br/><br/>Votre message passera<br/>de <span style='font-size:130%;'>" + option.lstDesComSource.length + "</span> à <span style='font-size:130%;'>" + option.lstDestComNettoye.length + "</span> destinataires.</div>").appendTo(contentElement)
                            $("<br/>").appendTo(contentElement)
                            $("<br/>").appendTo(contentElement)
                            $("<div style='display:inline-block;'/>").appendTo(contentElement).dxCtrlButton({
                                text: "Confirmer le nettoyage des destinataires",
                                onClick: function (e) {
                                    tt.hide()
                                    window.setTimeout(function () { option.onDemandeNettoie() }, 100)
                                    //jaugeDemarrage.mShow()
                                    //window.setTimeout(function () {
                                    //    option.bddCtrl.getObjet("com_destinataire").objetMetier.mNettoieAll(option.lstDesComSource, function (lstDestCom) {
                                    //        mVerifCreditEtEnvoi()
                                    //    })
                                    //}, 200)
                                }
                            })
                        }
                    }).dxCtrlTooltip("instance");
                    tt.show();
                } else {
                    mVerifCreditEtEnvoi()
                }
            }
        }).dxCtrlButton("instance")

        container.css("height", "")
    }

    function mVerifCreditEtEnvoi() {
        //on recharge les crédits dispos
        switch (table.nom) {
            case "com_email_envoi":
                nbCreditDispo = option.bddCtrl.objCptCli.objetMetier.mGetNbEmailDispo()
                idDisplayPlanCpteClient = 4
                break;
            case "com_sms_envoi":
                nbCreditDispo = option.bddCtrl.objCptCli.objetMetier.mGetNbSmsDispo()
                idDisplayPlanCpteClient = 3
                break;
            default: break;
        }
        var sendSms = new cSendSms(option.bddCtrl, option.data.body_txt, option.data.ajout_stop == "1")
        if (table.nom == "com_sms_envoi" && sendSms.mGetNbCaractereMessage() == 0) {
            mNotify("Votre message est vide. Veuillez saisir un message pour votre SMS", "warning", 6000)
        } else if (nbTotalCredit > nbCreditDispo) {
            //on a pas assez de crédit
            jaugeDemarrage.mHide()
            switch (table.nom) {
                case "com_email_envoi":
                    option.bddCtrl.objCptCli.objetMetier.mSignaleLimiteAbonnement(dxBtEnvoyer.element(), "Vous ne disposez pas<br/>de suffisament de crédit EMAIL.", "Acheter des crédits mails", 2, function () {
                        $("<div/>").appendTo("body").dxCtrlAchatPopup({
                            bddCtrl: option.bddCtrl,
                            typeProduit: "credit_email",
                            nb: nbTotalCredit,
                            onPaiement: function () {
                                jaugeDemarrage.mHide()
                                option.bddCtrl.mReloadTable("credit_sms", function () {
                                    if (typeof option.onDemandeReload != 'undefined') option.onDemandeReload()
                                    jaugeDemarrage.mHide()
                                })
                            }
                        })
                    })
                    break;
                case "com_sms_envoi":
                    option.bddCtrl.objCptCli.objetMetier.mSignaleLimiteAbonnement(dxBtEnvoyer.element(), "Vous ne disposez pas<br/>de suffisament de crédit SMS.<br/>Accédez à votre compte<br/>pour acheter des packs SMS.", "Acheter des crédits SMS", 3, function () {
                        $("<div/>").appendTo("body").dxCtrlAchatPopup({
                            bddCtrl: option.bddCtrl,
                            typeProduit: "credit_sms",
                            nb: nbTotalCredit,
                            onPaiement: function () {
                                jaugeDemarrage.mHide()
                                option.bddCtrl.mReloadTable("credit_sms", function () {
                                    if (typeof option.onDemandeReload != 'undefined') option.onDemandeReload()
                                    jaugeDemarrage.mHide()
                                })
                            }
                        })
                    })
                    break;
                default:
                    break;
            }
        } else {

            option.onDemandeEnvoi(option.lstDestComNettoye)
            jaugeDemarrage.mHide()

            //var lstNb = null
            //switch (table.nom) {
            //    case "com_email_envoi":
            //        var nbCreditParMessage = nbTotalCredit / option.lstDestComNettoye.length
            //        option.lstDestComNettoye.forEach(function (itemData) {
            //            itemData.nb_credit_par_message = nbCreditParMessage
            //        })
            //        lstNb.push({
            //            nb_credit: nbCreditParMessage,
            //            lstComDest: option.lstDestComNettoye
            //        })
            //        break;
            //    case "com_sms_envoi":
            //        option.lstDestComNettoye.forEach(function (itemData) {
            //            itemData.nb_credit_par_message = option.bddCtrl.getObjet(itemData).objetMetier.mGetCalculNbCreditToUseFromCodePays(nbCreditUnitaireFrance)
            //        })
            //        lstNb = mGetRepartCreditParCodePays(option.lstDestComNettoye)
            //        break;
            //}
            //option.bddCtrl.mAjaxCall({ command: "save_nb_credit_message", data: lstNb }, function (data) {
            //    //option.data.nb_credit_par_message = nbTotalCredit / option.lstDestComNettoye.length
            //    //option.bddCtrl.getObjet(option.data).mSaveChamp("nb_credit_par_message")
            //    option.onDemandeEnvoi()
            //    jaugeDemarrage.mHide()
            //})
        }
    }

    function mRempliPreview() {
        $DivPreview.css("width", ((container.innerWidth() == 0) ? "" : container.innerWidth() + 'px'))
        $DivPreview.empty()
        if (table.nom == "com_sms_envoi") {
            var $Td = $("<div style='white-space:nowrap;padding:15px 0 0px 0;font-size:160%;font-weight:bold;' class='dx-theme-accent-as-text-color'>Prévisualisation de votre message</div>").appendTo($DivPreview)
            if (option.data.body_txt.contains("|$a|")) {
                $("<div style='padding:0 10px;font-size:70%;font-style:italic;'>Votre message contient des hyper-liens.</diV>").appendTo($DivPreview)
                if (option.data.tracking == "1") {
                    $("<div style='padding:0 10px;font-size:70%;font-style:italic;'>Votre message est tracké. Tous vos liens sont remplacés par des liens trackés courts (32 caractères).</diV>").appendTo($DivPreview)
                    $("<div style='padding:0 10px;font-size:70%;font-style:italic;'>Ceux-ci seront généré pour au moment de l'envoi de vos sms.</diV>").appendTo($DivPreview)
                } else {
                    $("<div style='padding:0 10px;font-size:70%;font-style:italic;'>Votre message n'est pas tracké. Vos liens restent en l'état. Pour essayer de réduire la taille de votre message, activé le tracking pour générer des liens courts (32 caractères par liens).</diV>").appendTo($DivPreview)
                }
            }
            var $DivPreview2 = $("<div style='margin:5px 15px 15px 15px;padding:15px;border:" + theme.border + ";background-color:white;color:black;'/>").appendTo($DivPreview)
            var sendSms = new cSendSms(option.bddCtrl, option.data.body_txt, option.data.ajout_stop == "1")
            $DivPreview2.html(sendSms.mGetTxtWithLinkInHtml(option.data.tracking == "1"))
            $DivPreview.show();
        } else { $DivPreview.hide(); }
        $DivPreview.css("width", "")
    }

    var nbTotalCredit = 0
    var nbCreditDispo = 0
    var idDisplayPlanCpteClient = 0
    function mRempliResumeEnvoi() {
        $DivResumeEnvoi.css("height", (($DivResumeEnvoi.innerHeight > 0) ? $DivResumeEnvoi.innerHeight() + "px" : ""))
        $DivResumeEnvoi.empty()
        var $Table = $("<table style='width:100%'>").appendTo($DivResumeEnvoi)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='white-space:nowrap;padding:15px 0 5px 0;font-size:160%;;font-weight:bold;' colspan='2' class='dx-theme-accent-as-text-color'>Résumé de votre envoi</td>").appendTo($Tr)

        if (table.nom != "com_email_envoi" ||
            (table.nom == "com_email_envoi" && (option.lstDestComNettoye.length > parametre.nbre_destinataire_email_cc_cci_max || option.data.tracking == "1"))) {
            var $Tr = $("<tr/>").appendTo($Table)
            var $Td = $("<td style='white-space:nowrap;width:100%;opacity:0.2;'>Taille message</td>").appendTo($Tr)
            var $TdTailleMsg = $("<td style='white-space:nowrap;width:1px;font-size:300%;font-family:Barlow Condensed;text-align:right;'/>").appendTo($Tr)
            switch (table.nom) {
                case "com_email_envoi":
                    $TdTailleMsg.html((option.data.heberger_image == "1") ? option.data.taille_octet_ss_image.sizeFile(2) : option.data.taille_octet.sizeFile(2))
                    break;
                case "com_sms_envoi":
                    var sendSms = new cSendSms(option.bddCtrl, option.data.body_txt, option.data.ajout_stop == "1")
                    $TdTailleMsg.html(sendSms.mGetNbCaractereMessage(option.data.tracking == "1") + " car./" + sendSms.mGetNbCredit1MessageFrance(option.data.tracking == "1") + " sms")
                    break;
                default: break;
            }

            var nbCredit = 0
            nbTotalCredit = 0
            //nbre credit message
            var $Tr = $("<tr/>").appendTo($Table)
            var $Td = $("<td style='white-space:nowrap;width:100%;opacity:0.2;'>Nbre crédit utilisé<br/>pour l'ensemble des destinataires</td>").appendTo($Tr)
            var $Td = $("<td style='white-space:nowrap;width:1px;font-size:300%;font-family:Barlow Condensed;text-align:right;'/>").appendTo($Tr)
            switch (table.nom) {
                case "com_email_envoi":
                    nbCredit = Math.ceil(option.data.taille_octet / 1024 / 256)
                    $Td.html(Math.ceil(option.data.taille_octet / 1024 / 256) + " crédit" + ((nbCredit > 1) ? "s" : ""))
                    nbTotalCredit = nbCredit * option.lstDestComNettoye.length
                    break;
                case "com_sms_envoi":
                    var sendSms = new cSendSms(option.bddCtrl, option.data.body_txt, option.data.ajout_stop == "1")
                    option.lstDestComNettoye.forEach(function (comDest) {
                        comDest.nb_credit_par_message = sendSms.mGetNbCredit1Message(comDest.tel_code_pays, option.data.tracking == "1")
                    })
                    var lstNb = option.bddCtrl.getObjet(option.data).objetMetier.mGetRepartCreditParCodePays(option.lstDestComNettoye)
                    $Td.css("font-size", "100%")
                    var $TableDetailCredit = $("<table/>").appendTo($Td)
                    var $Tr = $("<tr style='line-height:0.8;text-align:center;vertical-align:bottom;font-size:90%;'/>").appendTo($TableDetailCredit)
                    var $TdPays = $("<td style='border-right:1px solid " + theme.backgroundcolorTooltip + ";padding:0 5px;opacity:0.3;'>Pays</td>").appendTo($Tr)
                    var $TdUnitaire = $("<td style='border-right:1px solid " + theme.backgroundcolorTooltip + ";padding:0 5px;opacity:0.3;'>Nb crédit<br/>unitaire</td>").appendTo($Tr)
                    var $TdNbComDest = $("<td style='border-right:1px solid " + theme.backgroundcolorTooltip + ";padding:0 5px;opacity:0.3;'>Nb<br/>destinataires</td>").appendTo($Tr)
                    var $TdTotal = $("<td style='padding:0 5px;opacity:0.3;'>Total</td>").appendTo($Tr)
                    lstNb.forEach(function (nb) {
                        var $Tr = $("<tr/>").appendTo($TableDetailCredit)
                        var indicatif = parametre.lstIndicatifTel.filter(function (o) { return o.code == nb.code_pays })[0]
                        var $TdPays = $("<td style='border-right:1px solid " + theme.backgroundcolorTooltip + ";padding:0 5px;'><table><tr><td><img src='https://flagcdn.com/w20/" + nb.code_pays.toLowerCase() + ".png' style='padding-right:5px;padding-top:5px;'/></td><td>" + indicatif.name + "</td></tr></td>").appendTo($Tr)
                        var $TdUnitaire = $("<td style='border-right:1px solid " + theme.backgroundcolorTooltip + ";text-align:center;padding:0 5px;'>" + nb.nb_credit + "</td>").appendTo($Tr)
                        var $TdNbComDest = $("<td style='border-right:1px solid " + theme.backgroundcolorTooltip + ";text-align:center;padding:0 5px;'>" + nb.lstComDest.length + "</td>").appendTo($Tr)
                        var $TdTotal = $("<td style='padding:0 5px;'>" + (nb.nb_credit * nb.lstComDest.length) + "</td>").appendTo($Tr)
                        nbTotalCredit += (nb.nb_credit * nb.lstComDest.length)
                    })
                    var $TableTot = $("<table/>").appendTo($Td)
                    var $TrTot = $("<tr/>").appendTo($TableTot)
                    var $TdTot = $("<td style='width:100%;'/>").appendTo($TrTot)
                    var $TdTot = $("<td style='width:1px;white-space:nowrap;font-size:140%;'>Total crédits SMS: " + nbTotalCredit + "</td>").appendTo($TrTot)
                    var $TdTot = $("<td style='width:1px;padding-left:5px;'></td>").appendTo($TrTot)
                    $("<div/>").appendTo($TdTot).dxCtrlButton({
                        icon: 'fas fa-hand-holding-dollar',
                        txtTooltip: "Détails des prix SMS par pays",
                        onClick: function (e) {
                            var tt = $("<div/>").appendTo("body").dxCtrlTooltip({
                                width: 250,
                                target: e.component.element(),
                                contentTemplate: function (contentElement) {
                                    contentElement.css("padding", "15px")
                                    var sendSms = new cSendSms(option.bddCtrl)
                                    sendSms.mGetDivTarifSmsParPays(contentElement)
                                }
                            }).dxCtrlTooltip("instance")
                            tt.show()
                        }
                    })
                    break;
                default: break;
            }

            //nbre crédit total
            var $Tr = $("<tr/>").appendTo($Table)
            var $Td = $("<td style='white-space:nowrap;width:100%;opacity:0.2;'>Nbre total de crédit<br/>pour votre envoi (" + option.lstDestComNettoye.length + " destinataires)</td>").appendTo($Tr)
            var $Td = $("<td style='white-space:nowrap;width:1px;font-size:300%;font-family:Barlow Condensed;text-align:right;font-weight:bold;'>" + nbTotalCredit + " crédits</td>").appendTo($Tr)
            nbCreditDispo = 0
            idDisplayPlanCpteClient = 0
            var $Tr = $("<tr/>").appendTo($Table)
            var $Td = $("<td colspan='2' style='text-align:right;'></td>").appendTo($Tr)
            switch (table.nom) {
                case "com_email_envoi":
                    nbCreditDispo = option.bddCtrl.objCptCli.objetMetier.mGetNbEmailDispo()
                    idDisplayPlanCpteClient = 4
                    break;
                case "com_sms_envoi":
                    nbCreditDispo = option.bddCtrl.objCptCli.objetMetier.mGetNbSmsDispo()
                    idDisplayPlanCpteClient = 3
                    break;
                default: break;
            }
            $Td.html("Vous disposez de <b>" + nbCreditDispo + " crédits</b> pour votre envoi.")
            if (nbTotalCredit > nbCreditDispo) {
                $Td.css("color", "red")
                $("<div style='text-align:right;'>Vous ne disposez pas<br/>de suffisament de crédits<br/>pour votre envoi.</div>").appendTo($Td)
                var $Div = $("<div style='text-align:right;'></div>").appendTo($Td)
                var $A = $("<a href='javascript:void(0)'>Acheter des crédits</a>").appendTo($Div)
                $A.on("click", function () {
                    $("<div/>").appendTo("body").dxCtrlAchatPopup({
                        bddCtrl: option.bddCtrl,
                        typeProduit: ((table.nom == "com_email_envoi") ? "credit_email" : "credit_sms"),
                        nb: ((table.nom == "com_email_envoi") ? 1000 : 5),
                        onPaiement: function () {
                            jaugeDemarrage.mShow()
                            option.bddCtrl.mReloadTable("credit_sms", function () { jaugeDemarrage.mHide() })
                        }
                    })
                    //$("<div/>").appendTo("body").dxCtrlOffrePopup({
                    //    bddCtrl: option.bddCtrl,
                    //    idSelectedOnglet: ((table.nom == "com_email_envoi") ? 2 : 3)
                    //})
                })
            } else {
                $Td.css("color", "darkgreen")
            }
        } else {
            nbTotalCredit = 0
            switch (table.nom) {
                case "com_email_envoi":
                    $("<div style='padding-top:5px;'>Votre message comporte moins de " + parametre.nbre_destinataire_email_cc_cci_max + " destinataires et vous ne demandez pas de tracking.<br/>Aucun crédit nécessaire.</div>").appendTo($DivResumeEnvoi)
                    break;
                case "com_sms_envoi":
                    break;
            }
        }
        $DivResumeEnvoi.css("height", "")
    }

    this.element = function () { return container }

    mConstruit();
}